import React from 'react';

const { Provider: PatchServiceProvider, Consumer: PatchServiceConsumer } = React.createContext();

export { PatchServiceProvider, PatchServiceConsumer };
